import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "max-w-md mx-auto text-center grid gap-6 mt-8" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" No Loan Calculations Created ")
const _hoisted_3 = { class: "mx-auto rounded-full bg-gray-400 flex items-center justify-center text-white h-48 w-48" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-900" }, " You have not created any commercial or personal loan calculations ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Heading = _resolveComponent("Heading")!
  const _component_IconLicense = _resolveComponent("IconLicense")!
  const _component_StartLoanButton = _resolveComponent("StartLoanButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Heading, null, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_IconLicense, { class: "w-24 h-24" })
    ]),
    _hoisted_4,
    _createVNode(_component_StartLoanButton, {
      class: "mx-auto",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('newLoan')))
    })
  ]))
}